import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CellText, Checkbox, Modal, Select } from '@opendate-app/setlist';

const money = (amount) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(amount) || 0);
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const listStyle = { border: '1px solid #E9EAEB', borderRadius: 12, overflow: 'hidden' };
const itemStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #E9EAEB' };
const amountStyle = { fontSize: 14, lineHeight: '20px', color: '#535862' };

const SeatRefundDialog = ({ rows, reasons, defaultReason, submitting, onClose, onConfirm }) => {
  const [reason, setReason] = useState(defaultReason);
  const [sendReceipt, setSendReceipt] = useState(true);
  const total = rows.reduce((sum, row) => sum + Number(row.refundAmount || 0), 0);
  const orders = new Set(rows.map((row) => row.orderId)).size;

  return (
    <Modal
      open
      type="error"
      icon
      width={480}
      data-seat-refund
      onClose={onClose}
      title={`Refund ${plural(rows.length, 'ticket', 'tickets')}?`}
      description={`${money(total)} goes back the way each fan paid, on ${plural(orders, 'order', 'orders')}. Fees are refunded too.`}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>Cancel</Button>
          <Button variant="destructive" disabled={submitting || !reason} onClick={() => onConfirm({ reason, sendReceipt })}>{`Refund ${money(total)}`}</Button>
        </>
      )}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={listStyle}>
          {rows.map((row, index) => (
            <div key={row.id} style={index === rows.length - 1 ? { ...itemStyle, borderBottom: 0 } : itemStyle}>
              <CellText primary={`${row.fan} · ${row.seat}`} supporting={`Order #${row.orderId} · ${[row.section, row.price].filter(Boolean).join(' ')}`} />
              <span style={amountStyle}>{money(row.refundAmount)}</span>
            </div>
          ))}
        </div>
        <Select
          label="Reason"
          value={reason}
          onChange={(value) => setReason(value && value.target ? value.target.value : value)}
          options={reasons.map((value) => ({ value, label: value }))}
        />
        <Checkbox label="Email fans their refund receipt" checked={sendReceipt} onChange={(event) => setSendReceipt(event.target.checked)} />
      </div>
    </Modal>
  );
};

SeatRefundDialog.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    fan: PropTypes.string,
    seat: PropTypes.string,
    orderId: PropTypes.number,
    section: PropTypes.string,
    price: PropTypes.string,
    refundAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })).isRequired,
  reasons: PropTypes.arrayOf(PropTypes.string).isRequired,
  defaultReason: PropTypes.string,
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

SeatRefundDialog.defaultProps = {
  defaultReason: null,
  submitting: false,
};

export default SeatRefundDialog;
